import React from 'react'
import {Context as StoreContext} from '../../contexts/Store'
import StoreForm from './form'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import EditIcon from '@mui/icons-material/Edit'
import CircularProgress from '@mui/material/CircularProgress'

import config from '../../config.json'

const StockCostToolbar = (props) => {
  const { selected, edit } = props

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Tiendas
      </Typography>
      {selected && 
        <React.Fragment>
          <Tooltip title="Editar">
            <IconButton onClick={() => edit(selected.name)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      }
    </Toolbar>
  )
}

const Stores = () => {
  const { stores, update, current, detail  } = React.useContext(StoreContext)

  const [openEdit, setOpenEdit] = React.useState(false)
  const openEditDialog = (s) => {
    setOpenEdit(true)
  }
  const updateStore = (store)=>{
    update(store.name, store, () => {
      setOpenEdit(false)
    })
  }

  const getReputation = (reputation) => {
    const rep = config.availableReputations.find(r => r.value === reputation)
    return rep?rep.label:''
  }

  return (
    <Box sx={{display: 'flex', justifyContent: 'center', width: "100%"}}>
      <Paper sx={{maxWidth: '800px'}}>
        <Stack>
          <StockCostToolbar selected={current} edit={openEditDialog} />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell alignt="left">Nombre</TableCell>
                  <TableCell alignt="left">Reputacion</TableCell>
                  <TableCell alignt="left">Color</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!stores && <CircularProgress size={27}/>}
                {stores && stores.map((store) => (
                  <TableRow
                    selected={current && current.name === store.name?true:false}
                    onClick={() => current && current.name === store.name?detail(null):detail(store)}
                    key={store.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="left">{store.name}</TableCell>
                    <TableCell align="left">{getReputation(store.reputation)}</TableCell>
                    <TableCell align="left">{store.color}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <StoreForm submit={updateStore} model={current} open={openEdit} close={() => setOpenEdit(false)}/>
        </Stack>
      </Paper>
    </Box>
  )
}
export default Stores